import React, { useState, useEffect } from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
import SelectField from "../Shared/SelectField";
import Button from "../Shared/Button";
import {
  getClinicCommunicationMethodService,
  getClinicPreferenceService,
  setClinicCommunicationMethodService,
  setClinicPreferenceService,
} from "../../services/clinic";
import Textarea from "../Shared/Textarea";

const GP_CLINIC_COMMUNICATION_METHODS = [
  { label: "COREPLUS", value: "coreplus" },
  { label: "SKYPE", value: "skype" },
  { label: "ZOOM", value: "zoom" },
  { label: "PHONE", value: "phone" },
];

const CLINIC_TYPE = [
  { label: "Metro", value: "metro" },
  { label: "Rural", value: "rural" },
];

const ClinicCommunicationMethod = () => {
  const clinics = useSelector((state) => state.app.clinics);
  const [clinicCommunicationMethod, setClinicCommunicationMethod] = useState({});
  const [clinicPreference, setClinicPreference] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const getClinicCommunicationMethod = async () => {
      const result = await getClinicCommunicationMethodService();
      setClinicCommunicationMethod(result);
    };
    getClinicCommunicationMethod();
  }, []);

  useEffect(() => {
    const getClinicPreference = async () => {
      const result = await getClinicPreferenceService();
      setClinicPreference(result);
    };
    getClinicPreference();
  }, []);

  const handleClinicCommunicationMethodChange = (clinicId, methodValue) => {
    setClinicCommunicationMethod((ccm) => ({
      ...ccm,
      [clinicId]: methodValue,
    }));
  };

  const handleClinicReferenceChange = (clinicId, obj) => {
    setClinicPreference((pre) => ({
      ...clinicPreference,
      [clinicId]: {
        ...clinicPreference[clinicId],
        ...obj,
      },
    }));
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    await setClinicCommunicationMethodService(clinicCommunicationMethod);
    await setClinicPreferenceService(clinicPreference);
    setIsSubmitting(false);
  };

  return (
    <div className="columns">
      <div className="column is-two-thirds">
        <div className="menu-label">Clinic Communication Method</div>
        <div className="table-container clinic-communication-method">
          <table className="table is-fullwidth is-stripe is-hoverable is-size-7">
            <thead>
              <tr>
                <th>Clinic Name</th>
                <th>Communication Method</th>
                <th>Metro/Rural</th>
                <th>Note</th>
              </tr>
            </thead>
            <tbody>
              {clinics.map((clinic) => (
                <tr key={clinic.id}>
                  <td>{clinic.name}</td>
                  <td>
                    <SelectField
                      options={GP_CLINIC_COMMUNICATION_METHODS}
                      onChange={(e) => handleClinicCommunicationMethodChange(clinic.id, e.target.value)}
                      value={_.has(clinicCommunicationMethod, clinic.id) ? clinicCommunicationMethod[clinic.id] : ""}
                    />
                  </td>
                  <td>
                    <SelectField
                      options={CLINIC_TYPE}
                      onChange={(e) => handleClinicReferenceChange(clinic.id, { type: e.target.value })}
                      value={_.get(clinicPreference, [clinic.id, "type"], "")}
                    />
                  </td>
                  <td className="note">
                    <Textarea
                      value={_.get(clinicPreference, [clinic.id, "note"], "")}
                      onChange={(e) => handleClinicReferenceChange(clinic.id, { note: e.target.value })}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Button text="Submit" isLoading={isSubmitting} onClick={handleSubmit} />
      </div>
    </div>
  );
};

export default ClinicCommunicationMethod;
